<template>
    <div>
        <div class="bg-light shadow-md rounded p-2">
            <!-- {{  R }} -->
            <!-- Detalles de la reserva -->
            <nav class="navbar navbar-light bg-light rounded justify-content-between">
                <div class="row col-12">
                    <!-- {{ reserva }} -->
                    <div class="col-3">
                        <span class="h6">Reserva</span><br>
                        <span class="h2 text-blue"><b>{{ R.id }}</b></span><br><small>{{ R.fh }}</small>
                    </div>
                    <div class="col-5">
                        <div class="h3 text-primary text-bold mt-1">{{ R.xstd }}</div>
                        <div>
                            <span class="h9 font-italic">{{ R.usu }} <br></span>
                            <span class="text-info small"><b>{{ R.agencia }}</b></span>
                            <!-- <div><span class="h8">Emitida <b>{{ R.fh }}</b></span></div> -->
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="btn-group">
                            <b-btn variant="outline-success" size="sm" v-show="R.cerrada == '0' && R.std < 4"
                                @click="reserva_pdf">
                                <i class="mr-1 fa fa-print"></i>RESERVA
                            </b-btn>
                            <!-- <b-btn class="ml-2" variant="outline-success" size="sm"
                                v-show="R.std<4 && Number(R.pte)>0" @click="pagoTarjeta">
                                <i class="mr-1 fa fa-credit-card"></i>PAGO TARJETA
                            </b-btn> -->
                            <b-btn class="ml-2" variant="outline-success" size="sm" v-show="R.cerrada=='0' && R.std==3"
                                @click="bonos_pdf">
                                <i class="mr-1 fa fa-print"></i>BONOS
                            </b-btn>
                            <b-btn class="rl-action mx-sm-2" variant="outline-danger" size="sm"
                                v-show="R.cerrada=='0' && R.std<=3" @click="anular">
                                <i class="mr-1 fa fa-trash"></i>ANULAR
                            </b-btn>
                        </div>
                    </div>
                </div>
            </nav>
            <hr>
            <!-- Información del Hotel -->
            <div class="row">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-12">
                            <!-- <strong>{{ reserva.hotel }}</strong>
                            <address>
                                <p><img :src="require('@/assets/css/img/map-marker-icon.svg')" />
                                    {{ reserva.pobla}}
                                </p>
                            </address> -->
                            <!-- <img class="img-fluid rounded" :src="imgUrl()" width="80%" :alt="R.hotel"> -->
                            <!-- </div>
                        <div class="col-9"> -->
                            <div class="row">
                                <div class="col-10 h6 text-secondary text-bold">{{ R.hotel }}
                                    <div class="h7">
                                        <img :src="require('@/assets/css/img/map-marker-icon.svg')" />
                                        {{ R.hpob }}
                                    </div>
                                    <hr>
                                </div>
                                <!-- <div class="col-6">
                                    <span class="small">Emitida</span>
                                    <p><b>{{ R.fh }}</b></p>
                                </div> -->
                            </div>

                            <div class="row">
                                <div class="col-3">
                                    <span class="small">Fecha Entrada</span>
                                    <p><b>{{ R.fhe }}</b></p>
                                </div>
                                <div class="col-2">
                                    <span class="small">Fecha Salida</span>
                                    <p><b>{{ R.fhs }}</b></p>
                                </div>
                                <div class="col-4"><span class="small">Noches</span>
                                    <p><b>{{ R.noc }}</b></p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3">
                                    <span class="small">Habitación</span>
                                    <p><strong>{{ R.xtph }}</strong></p>
                                </div>
                                <div class="col-2"><span class="small">Personas</span>
                                    <p><strong>{{ R.pax }}</strong></p>
                                </div>
                                <div class="col-4">
                                    <i class="fas fa-credit-card text-secondary"></i>
                                    <span class="ml-1">Importe reserva: </span><strong>{{ reserva.tot }} €</strong>
                                    <p class="mb-0 small"><span class="d-table-cell font-italic">Precio x
                                            Persona:</span><span class="d-table-cell  font-weight-bold pl-1">{{
                                            reserva.pre }} €</span></p>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <!-- Información de huéspedes -->
            <div class="row">
                <div class="col-sm-5">
                    <i class="fas fa-users text-secondary"></i>
                    <span class="ml-1 mt-1">Clientes:</span><br>
                    <span class="text-bold">{{ R.nom1 }}<br>{{ R.nom2 }}<br>{{ R.nom3 }}</span>
                </div>
                <div class="col-sm-2">
                    <span class="small ml-1 mt-1">DNI/NIF</span><br>
                    <span class="text-bold">{{ R.dni1 }}<br>{{ R.dni2 }}<br>{{ R.dni3 }}</span>
                </div>
                <div class="col-sm-5">
                    <span class="mt-1 font-italic">Teléfonos</span><br>
                    <span class="text-bold">{{ R.tfn1 }}<br>{{ R.tfn2 }}</span>
                    <p v-if="R.email > ''">
                        <span class="font-italic">Email :</span>
                        <span class="d-table-cell text-bold pl-2">{{ R.email }}</span>
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <p class="mt-2 mb-0" v-if="R.obs>''">
                        <span class="d-table-cell font-italic">Observaciones :</span>
                        <span class="d-table-cell text-bold pl-2">{{ R.obs }} </span>
                    </p>
                </div>
            </div><!-- Fin información de huéspedes -->

            <hr>

            <!-- Información de Servicios -->
            <div class="row">
                <div class="col-sm-5"><i class="fas fa-utensils text-secondary"></i> <span class="ml-1">Servicios:
                    </span><strong>{{ R.xreg }}</strong>
                    <p class="mt-2 mb-0">
                        <span class="d-table-cell font-italic">Primer servicio:</span>
                        <span class="d-table-cell text-bold pl-2">{{ R.xent }}</span>
                    </p>
                    <p class="mt-1 mb-0">
                        <span class="d-table-cell font-italic">Último servicio:</span>
                        <span class="d-table-cell text-bold pl-2">{{ R.xsal }}</span>
                    </p>
                </div>
                <div class="col-sm-7">
                    <i class="fas fa-bus text-secondary"></i>
                    <span class="ml-1">Transporte: </span>
                    <p class="h8 text-bold" v-if="R.tra == '0'">SIN BUS/TRANSPORTE</p>
                    <p class="h8 text-bold" v-else>{{ R.lug1 }} {{ R.hora1 }}</p>
                </div>

            </div> <!-- Fin información de servicios -->

            <!-- <hr> -->

        </div>


    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'reservaInfo',
    components: {
        //publicidad,
    },
    data() {
        return {
            message: 'Error',
        };
    },
    computed: {
        ...mapState(['G', 'auth', 'iReserva', 'errores']),

        cta() {
            return this.auth.user;
        },
        admon() {
            return (this.cta.dep == 'ADMON');
        },
        reserva() {
            return this.iReserva;
        },
        R() {

            const estados = ['', 'PETICIÓN', 'CONFIRMADA', 'FACTURADA', 'ANULADA', 'CANCELADA'];
            const regimen = { A: 'Solo Alojamiento', AD: 'Alojamiento y Desayuno', MP: 'Media Pensión', PC: 'Pensión Completa' };
            const servicios = { D: 'Desayuno', A: 'Almuerzo', C: 'Cena' };
            const tphab = { 1: 'INDIVIDUAL', 2: 'DOBLE COMP', 3: 'DOBLE', 4: 'TRIPLE' };

            let r = this.reserva;

            r.xstd = estados[r.std];
            //r.pax = (r.d3 > '' ? 3 : (r.d2 > '' ? 2 : 1)) || 0;
            r.xpax = this.personas(r.tpp);
            r.xpte = this.$util.SN(r.pte);
            //r.tph=(r.pax==3?4:(r.pax==2?3:(r.ind=='1'?1:2)));
            r.xtph = tphab[r.tph];
            r.tpp = String(r.pax) + '0';
            r.xreg = regimen[r.reg];
            r.xent = servicios[r.ent1];
            r.xsal = servicios[r.sal1];
            /* //calculos
            r.pre = this.turno.pre;
            r.sup = r.ind=='0' ? 0 : Number(this.turno.sup);
            r.tot = Number(r.pre * r.pax) + r.sup;
            r.com = Number(r.pax * this.turno.com);
            r.pag = Number(r.tot) - Number(r.com); */

            return r;
        },

    },
    methods: {
        ...mapMutations(['loading', 'alerta', 'modal']),
        ...mapActions(['exec', 'error']),

        //BANCO - TARJETA
        async pagoTarjeta() {
            //alert(this.RES.pte);
            let msg = "Estas Seguro PAGO TARJETA ? <br>* Reserva <b>" + this.iReserva.id + "</b><br>* Importe: <b>" + this.iReserva.pte + "<b>";
            let r = await this.$root.$msgConf(msg, 'RESERVAS');
            if (r) this.pagoBanco();
        },
        pagoBanco() {
            let url = this.G.url_tpv;
            let arg = new Date().getTime() + '|5.' + this.iReserva.id + '|' + this.RES.pte;

            window.open(url + '?w=' + arg, '_blank');
        },

        //RESERVA
        async reserva_pdf() {
            let url = "https://viajescemo.com/castellonsenior/emision_reserva.php?w=" + new Date().getTime() + "|" + this.iReserva.id;
            window.open(url, '_blank');
        },
        async reserva_pdf0() {
            //alert('Reserva');
            let r = await this.exec({
                api: 'reserva_pdf',
                arg: { sid: this.auth.token, id: this.iReserva.id },
            });
            if (r.error) {
                this.modal({ tit: "Reserva", msg: r.datos });
            } else {
                window.open(this.G.url_tmp + r.datos);
            }
        },
        //BONOS
        async bonos_pdf() {
            let url = "https://viajescemo.com/castellonsenior/emision_bonos.php?w=" + new Date().getTime() + "|" + this.iReserva.id;
            window.open(url, '_blank');
        },
        async bonos_pdf0() {
            let r = await this.exec({
                api: 'bonos_pdf',
                arg: { sid: this.auth.token, id: this.iReserva.id },
            });
            if (r.error) {
                this.modal({ tit: "Bonos", msg: r.datos });
            } else {
                window.open(this.G.url_tmp + r.datos);
            }
        },
        //ANULAR
        async anular() {
            if (this.R.cerrada=='1') {
                this.modal({ tit: "RESERVA", msg: 'Reserva ya Iniciada ó Finalizada\nNo puede ser Anulada', time: 0 });
                return;
            }
            //alert('Anular');
            let msg = "Estas Seguro ANULAR Reserva Nº " + this.iReserva.id + " ?";
            let r = await this.$root.$msgConf(msg, 'RESERVAS');
            if (!r) return;

            //anulamos reserva
            r = await this.exec({ api: 'anular', arg: { token: this.auth.token, id: this.iReserva.id } });

            if (await this.error({ r })) return;

            msg = (!r.error ? `RESERVA Nº ${this.iReserva.id} ha sido ANULADA ...` : r.msg);
            this.modal({ tit: "RESERVA", msg: msg, time: 0 });

            //this.$emit('listado');
            //this.$parent.listado();

            this.$store.state.iReserva = r.r[0];
        },

        imgUrl() {
            let url = `${this.G.url_img}?w=123654|vc_agencias|hoteles_img|||${this.iReserva.hot}`;
            return url;
        },

        personas(tpp) {
            let adu = Number(tpp.charAt(0));
            let nin = Number(tpp.charAt(1));
            //let pax=adu+nin;

            let pax = String(adu) + ' Adulto' + (adu > 1 ? 's' : '') + (nin > 0 ? ' ' + String(nin) + ' Niño' : '') + (nin > 1 ? 's' : '');
            return pax;
        },

        //modal
        close() {
            this.$bvModal.hide('modal_reservaInfo');
        }

    },
}
</script>
